import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';

export const StyledCloseButton = styled(Button, {
  '&.abyss-button-root': {
    margin: '0',
    width: '280px',

    '@media (max-width: 464px)': {
      margin: '18px 0 10px',
      width: '288px',
    },
  },
});
